import { UtteranceType } from "../utterances/utterances.utility.decl";

import { TalkRatio } from "./talk_ratio.utility.decl";

export function computeTalkRatio(
  utterances?: (UtteranceType | null)[] | null
): TalkRatio {
  const list = utterances ?? [];

  const [map, total] = list.reduce(
    ([accumulatedMap, accumulatedTotal], utterance) => {
      if (!utterance) {
        return [accumulatedMap, accumulatedTotal];
      }

      const sum = utterance.endTime - utterance.startTime;

      if (!accumulatedMap.has(utterance.channel)) {
        accumulatedMap.set(utterance.channel, sum);
        return [accumulatedMap, accumulatedTotal + sum];
      }

      accumulatedMap.set(
        utterance.channel,
        accumulatedMap.get(utterance.channel)! + sum
      );

      return [accumulatedMap, accumulatedTotal + sum];
    },
    [new Map<number, number>(), 0]
  );

  return new Map(
    [...map.entries()].map(([key, value]) => [
      key,
      Math.round((value / total) * 100),
    ])
  );
}
